<template>
  <form @submit.prevent="submit">
    <AhaInputTag
      class="mb-2"
      v-model="tags"
      :allow-duplicate="false"
      :placeholder="tags.length === 0 ? 'Enter tags, comma separated' : ''"
    />

    <AhaButton type="submit" :submitting="isSubmitting">
      Save
    </AhaButton>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'

// utils
import utils from '@/util'

// api
import PresentationAPI from '@/api/presentation'

export default {
  data() {
    return {
      tags: [],
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
  mounted() {
    this.tags = this.presentation.tags || this.tags
  },
  methods: {
    ...mapActions(['patchPresentationAction']),
    async submit() {
      this.isSubmitting = true
      const payload = {
        tags: this.tags,
      }

      try {
        await PresentationAPI.patchPresentation(this.presentation.id, payload)
        utils.showToastSuccess(`Saved ${this.tags.length} tag(s)`)
      } catch {
        utils.showToastError('Saved failed. Should alert development team.')
        return
      } finally {
        this.isSubmitting = false
      }

      this.patchPresentationAction(payload)
    },
  },
}
</script>
